export default () => {
  return [
    {
      'id': 1,
      'title': 'Färg (RGB)'
    },
    {
      'id': 2,
      'title': 'Färg (CMYK)'
    },
    {
      'id': 3,
      'title': 'Svart/Vit'
    },
    {
      'id': 4,
      'title': 'Färg (Pantone)'
    },
    {
      'id': 5,
      'title': 'Färg (Pantone/CMYK)'
    },
    {
      'id': 6,
      'title': 'Ögats färgrymd'
    }
  ];
};

